import icons from "Common/Icons";
export const loginMessages = {
    email: "Email Id is required",
    password: "Password is required",
};
export const BPI_V1_ADOLESCENT_LABEL = [
	{
		"chart_id": 4,
    "chart_score": 0,
		"title": "Present Moment Awareness",
		"left_option": "I spend most of my time lost in thought about the past or future",
		"right_option": "I spend most of my time paying attention to what is happening in the present "
	},
	{
		"chart_id": 5,
    "chart_score": 0,
		"title": "Acceptance",
		"left_option": "I constantly struggle with my thoughts and feelings",
		"right_option": "I willingly accept my thoughts and feelings even when I don't like them"
	},
	{
		"chart_id": 6,
    "chart_score": 0,
    "title": "Defusion",
		"left_option": "My thoughts tell me how things really are, and determine what I do",
		"right_option": "I see each of my thoughts as just another thought what I do next is up to me"
	},
	{
		"chart_id": 7,
    "chart_score": 0,
		"title": "Awareness of Self",
		"left_option": "Deep down, my thoughts and feelings are the real me",
		"right_option": "My thoughts and feelings come and go, but deep down the real me doesn't change"
	},
	{
		"chart_id": 8,
    "chart_score": 0,
		"title": "Values Clarity",
		"left_option": "I don't know what I want from life",
		"right_option": "I am clear about what I choose to value in life"
	},
	{
		"chart_id": 9,
    "chart_score": 0,
		"title": "Committed Action",
		"left_option": "I do not manage to act on the things I care about",
		"right_option": "I work out what I need to do about the things I care, and do it"
	}
]

export const FOLLOWUP_NOTES = [
  "The patient has a single session plan, the follow-up will only appear in the prescription PDF. The patient needs to subscribe plans for scheduling their next appointment.",
  // "Please complete the Instructions to Care Admin form to request a ticket.",
]

export const Emotion_Colors = {
  Positive  : "#32D583",
  Negative  : "#F97066",
  Neutral   : "#9DA4AE",
  Mixed     : "#F38744"
}
const colorCode = {
  default: {
    id: 1,
    org_name: "",
    color:"#6938EF",
    teal_50:"#F4F3FF",
    teal_100:"#EBE9FE",
    teal_300: "#BDB4FE",
    teal_400:"#9B8AFB",
    teal_500: "#7A5AF8",
    teal_600:"#6938EF",
    teal_700:"#5925DC",
    teal_800:"#4A1FB8",
    teal_900:"#3E1C96",
    green_100:"#D3F8DF",
    mini_logo: "https://dsqsqcjhmnoxg.cloudfront.net/partner/healthedge/logo.svg",
    full_logo: "https://dsqsqcjhmnoxg.cloudfront.net/partner/healthedge/name.svg",
    dashbord_tick_icon: "hue-rotate(85deg)",
    menu_icon:
      "invert(39%) sepia(56%) saturate(6125%) hue-rotate(201deg) brightness(1) contrast(1)",
    label: "HealthEdge",
  },
  star_health:{
      id:2,
      org_name: "Star Health and Allied Insurance",
      color:"#7F56D9",
      teal_50: "#F9F5FF",
      teal_100:"#F4EBFF",
      teal_300: "#D6BBFB",
      teal_400:"#B692F6",
      teal_500: "#9E77ED",
      teal_600:"#7F56D9",
      teal_700:"#6941C6",
      teal_800:"#53389E",
      teal_900:"#42307D",
      green_100:"#F4EBFF",
      mini_logo : 'https://dsqsqcjhmnoxg.cloudfront.net/partner/securekloud/logo.svg',
      full_logo : 'https://dsqsqcjhmnoxg.cloudfront.net/partner/securekloud/name.svg',
      dashbord_tick_icon : "hue-rotate(82deg)",
      menu_icon : "invert(39%) sepia(56%) saturate(6125%) hue-rotate(201deg) brightness(1) contrast(1)",
    },
  securekloud:{
    id:3,
    org_name: "Securekloud",
    color:"#1570EF",
    teal_50: "#EFF8FF",
   teal_100:"#D1E9FF",
   teal_300: "#84CAFF",
   teal_400:"#53B1FD",
   teal_500: "#2E90FA",
   teal_600:"#1570EF",
   teal_700:"#175CD3",
   teal_800:"#1849A9",
   teal_900: "#194185",
   green_100:"#F4EBFF",
   mini_logo : 'https://dsqsqcjhmnoxg.cloudfront.net/partner/securekloud/logo.svg',
   full_logo : 'https://dsqsqcjhmnoxg.cloudfront.net/partner/securekloud/name.svg',
   dashbord_tick_icon : "hue-rotate(82deg)",
   menu_icon : "invert(39%) sepia(56%) saturate(6125%) hue-rotate(201deg) brightness(1) contrast(1)",
   label : "Securekloud",
   }
}
export const ORG_ID = {
          "default":colorCode.default,
          "Star Health and Allied Insurance":colorCode.securekloud,
          "Securekloud":colorCode.securekloud,
          "localhost:3001":colorCode.securekloud,
          "sk-app.dev.niyama.ai":colorCode.securekloud,
          "sk-app.tst.niyama.ai":colorCode.securekloud,
          "sk-app.stg.niyama.ai":colorCode.securekloud,
          "sk-app.demo.niyama.ai":colorCode.securekloud,  
          "sk-app.app.niyama.ai": colorCode.securekloud,
}
export const validateErrMessages = {
    checkEmailMessage: 'This field should contain only email id',
    checkMobileNumberMessage: 'Please enter valid mobile number',
    validatePasswordMessage1: 'Password must be minimum of 8 characters',
    validatePasswordMessage2: 'Password must be maximum of 32 characters',
    validatePasswordMessage3: 'Password must be atleast one uppercase letter, lowercase letter, number and symbol',
    validateConfirmPasswordMessage1: 'Confirm password must be minimum of 8 characters',
    validateConfirmPasswordMessage2: 'Password must be maximum of 32 characters',
    validateConfirmPasswordMessage3: 'Passwords entered do not match.',
    noSpaceAllowed: 'No spaces allowed',
    validateIsAlphabetsOnly: 'Please enter alphabets only',
    otpMessage1: 'Valid otp is required to proceed',
    otpMessage2: 'Please enter valid OTP',
    validateIsNumber: 'This field accept only valid numeric values',
    validateIsAlphaNumeric: 'This field accept only alphanumeric and special characters',
    validateIsAlphabetsPunctuations: 'Please enter a valid name',
    validateIsTestName: 'Please enter a valid Test name',
    validateIsAlphabetsPunctuationsComments: 'Please enter a valid comments',
    validateIsAlphabets: 'This field accept only alphabetical values',
    checkZipCodeMessage: "This field accept only valid zipcodes",
    validateAddressMessage: "Please enter valid address",
    validateDosageMessage: "Please enter valid frequency",
    validateJobChangeMessage: "This field can only contain range between 0 and 10",
    checkWeightMessage: "This field must contain minimum value 10 and maximum value 200",
    checkHeightMessage: "This field must contain minimum value 30 and maximum value 200",
    validErrorMessage: "This field accept only valid input values",
    lengthErrorMessage: "This field exceeds maximum number of characters",
    length100ErrorMessage: "This field exceeds maximum 100 number of characters",
    length250ErrorMessage: "This field exceeds maximum number of 250 characters",
    maxLimitErrorMessage: "This field exceeds maximum limits",
    negativeValueMessage: "This field accepts only positive numbers",
    negativeValueMessage: "This field accepts only positive numbers",
    documentNumberIsAlphaNumeric: 'This field accept only alphanumeric values',
    documentNumberIsNumber: 'This field accept only numeric values',
    documentNumberGreaterThanZero: 'This field accept only valid numeric values',
    validateIsAlphabetsName:'Please enter a valid name',
    validateEducation: 'This field exceeds maximum limits',
    validateemailduplicate: 'Account Holder and Care Receiver Email cannot be same',
    validatemobileduplicate: 'Account Holder and Care Receiver Mobile cannot be same',
    termAndCondition:"Please read and accept the Terms and Conditions and acknowledge the Privacy Policy",
    adolscentTermAndCondtion : "Please read and accept the Parental Consent for Child/Adolescent  Health  Treatment",
    passwordHintMessage:"Please ensure all password hints are satisfied.",
    firstNameLastNameValidation: "This field exceeds maximum number of 50 characters",
    SpecialCharecterValidation:"Please enter a valid name",
    checkValidDiscountMessage:"Please give a valid discount (min:1.00% max:100%)"

};

export const PHILABEL = {
    socio_demographic_detail: "Socio Demographic Details",
    presenting_mental_health_complaints: "Presenting Complaints",
    physical_health_complaints: "Physical Health Complaints",
    evolution_of_illness: "Evolution Of Illness",
    past_mental_health_history: "Past Mental Health History",
    past_hospitalization_history: "Past Hospitalization History",
    family_hospitalization_history: "Family Hospitalization History",
    mental_illness_in_the_family: "Mental Illness In The Family",
    physical_illness_in_the_family: "Physical Illness In The Family",
    birth_and_childhood_history: "Birth & Childhood History",
    menstruation_detail: "Menstruation Details",
    educational_detail: "Education Details",
    occupational_detail: "Occupational Details",
    sexual_health: "Sexual Health",
    energy_level_and_exercise_routine: "Energy Level & Exercise Routine",
    sleep_detail: "Sleep Details",
    medical_document: "Medical Document",
    blood_test: "Blood Test",
    physical_characteristics: "Ayurvedic Constitutional Analysis",
    psychological_characteristics: "Psychological Characteristics",
    gut_assessment: "Gut Assessment",
    constitutional_analysis: "Ayurvedic Constitutional Analysis",
}

export const PHISummaryInitialData = {
    "socio_demographic_detail": "You have not filled Socio Demographic Details",
    "presenting_mental_health_complaints": "Do you have any present mental health issues?",
    "physical_health_complaints": " Do you have any physical health complaints?",
    "evolution_of_illness": "You have not filled this yet.",
    "past_mental_health_history": "Do you have any past mental health history?",
    "past_hospitalization_history": "Do you have any past hospitalization history?",
    "family_hospitalization_history": "Do you have any family hospitalization history?",
    "mental_illness_in_the_family": "Do you have any mental illness in the family?",
    "physical_illness_in_the_family": "Do you have any physical illness in the family?",
    "birth_and_childhood_history": "You have not filled this yet.",
    "menstruation_detail": "You have not filled this yet.",
    "educational_detail": "You have not filled this yet.",
    "occupational_detail": "You have not filled this yet.",
    "sexual_health": "You have not filled this yet.",
    "energy_level_and_exercise_routine": "You have not filled this yet.",
    "sleep_detail": "You have not filled this yet.",
    "medical_document": "You have not submitted Medical Documents.",
    "blood_test": "You have not filled this yet.",
    "constitutional_analysis": "You have not filled this yet"
}
export const PHISummaryDoctorUpdate = {
    "socio_demographic_detail": "Client has not filled Socio Demographic Details",
    "presenting_mental_health_complaints": "Do you want to update the present mental health complaints for the client?",
    "physical_health_complaints": "Do you want to update the physical health complaints for the client?",
    "evolution_of_illness": "You have not filled this yet.",
    "past_mental_health_history": "Do you want to update the past mental health history for the client?",
    "past_hospitalization_history": "Do you want to update the past hospitalization history for the client?",
    "family_hospitalization_history": "Do you want to update the family hospitalization history for the client?",
    "mental_illness_in_the_family": "Do you want to update the mental illness in the family for the client?",
    "physical_illness_in_the_family": "Do you want to update the physical illness in the family for the client?",
    "birth_and_childhood_history": "Do you want to update the birth and childhood history for the client?",
    "menstruation_detail": "Do you want to update the menstruation details for the client?",
    "educational_detail": "Do you want to update the educational details for the client?",
    "occupational_detail": "Do you want to update the occupational details for the client?",
    "sexual_health": "Do you want to update the sexual health for the client?",
    "energy_level_and_exercise_routine": "Do you want to update the energy level and exercise routine for the client?",
    "sleep_detail": "Do you want to update the sleep details for the client?",
    "medical_document": "Do you want to update the medical document for the client?",
    "blood_test": "Do you want to update the blood test for the client?",
    "constitutional_analysis": "Do you want to update the ayurvedic constitutional analysis for the client?"
}
export const PHISummaryNotApplicableData = {
    "presenting_mental_health_complaints": "Click edit to change present mental health issues.",
    "physical_health_complaints": "Click edit to change physical health complaints.",
    "evolution_of_illness": "Click edit to change evolution of illness.",
    "past_mental_health_history": "Click edit to change past mental health history.",
    "past_hospitalization_history": "Click edit to change past hospitalization history.",
    "family_hospitalization_history": "Click edit to change family hospitalization history.",
    "mental_illness_in_the_family": "Click edit to change mental illness in the family.",
    "physical_illness_in_the_family": "Click edit to change physical illness in the family.",
    "birth_and_childhood_history": "Click edit to change birth and childhood history.",
    "menstruation_detail": "Click edit to change menstruation detail.",
    "educational_detail": "Click edit to change educational detail.",
    "occupational_detail": "Click edit to change occupational detail.",
    "sexual_health": "Click edit to change sexual health.",
    "energy_level_and_exercise_routine": "Click edit to change energy level and exercise routine.",
    "sleep_detail": "Click edit to change sleep detail.",
    "medical_document": "Click edit to change medical document.",
    "blood_test": "Click edit to change blood test.",
    "constitutional_analysis": "Click edit to change ayurvedic constitutional analysis."
}

export const RESTRICTED_LOGO_REDIRECTION_PATHS = ['/logged-in-user/video-consultation', '/doctor/video-consultation', '/guest-user/login', '/logged-in-user/privacy-policy', '/logged-in-user/terms-of-use', '/guest-user/privacy-policy', '/guest-user/terms-of-use'];

export const GUEST_ROUTES = [
  "/guest-user/take-assessment/adult_stress",
  "/guest-user/take-assessment/adult_emotion",
  "/guest-user/take-assessment/adolescent_emotion",
  "/guest-user/funneling-questions",
  "/guest-user/take-assessment/senior_adult_senior_adult",
  "/guest-user/new-select-assessment"
];

export const PUBLIC_ROUTES = [
  "/guest-user/dashboard",
  "/guest-user/login",
  "/guest-user/privacy-policy",
  "/guest-user/terms-of-use",
  "/guest-user/funneling-questions",
];

export const SUPPORTED_IMG_FILES = [
"image/jpg",
"image/jpeg",
"image/png",
];

export const SUPPORTED_DOC_FILES = [
  "application/pdf"
  ];

export const placeholder = {
    dropdown: "Select",
    textbox: "Type here",
    datepicker: "Select a date",
    textbox_small: "Type here",
    comments: "Type here",
    number: "Enter value"
}
export const PREDEF_OFFSET = -330;

export const AVAILABLE_CELL_COLOR = "#B3B8DB";

export const NON_AVAILABLE_CELL_COLOR = "#FFFFFF";

export const APPOINTMENT_COLOR = "#F9FAFB";

export const SHOW_AVAILABILITIES_COLOR = "#8E8ED6";

export const HOLIDAY_CELL_COLOR = "#E3E3DF";

export const HOUR_FORMAT = "12";
  
export const HOURS_LENGTH = 24;

export const START_HOUR = 0;

export const STEP = 30;

export const BORDER_HEIGHT = 2;

export const TABLE_HEIGHT = 600;

export const END_HOUR = 24;

export const START_TIME_TXT = "Start Time";

export const END_TIME_TXT = "End Time";

export const AVAILABILITY_ADD_ACTION = "ADD";

export const AVAILABILITY_EDIT_ACTION = "EDIT";

export const CONN_CHECKING_STS = "Checking Connectivity";

export const CONN_SUCCESS_STS = "Connection Successful";

export const CONN_ERROR_STS = "Connection Error";

export const AUDIO_NOT_TESTED = "Audio Not Tested";

export const AUDIO_CHECKING_STS = "Testing Audio";

export const AUDIO_SUCCESS_STS = "Audio working fine";

export const AUDIO_ERROR_STS = "Cannot connect to audio";

export const VIDEO_NOT_TESTED = "Video not tested";

export const VIDEO_CHECKING_STS = "Testing Video";

export const VIDEO_SUCCESS_STS = "Video working fine";

export const VIDEO_ERROR_STS = "Cannot connect to video";

export const PYMT_CODE_DETAILS = [
    {
      code: "0002",
      status: "pending",
      msg: "Payment Pending!",
      redirectPath: "/logged-in-user/dashboard",
    },
    {
      code: "0300",
      status: "success",
      msg: "Payment Successfull!",
      redirectPath: "/logged-in-user/dashboard",
    },
    {
      code: "0399",
      status: "error",
      msg: " Payment Failed!",
      redirectPath: "/logged-in-user/subscription-plan",
    },
  ];


export const ROLES_DETAILS = [
  {
    roleId : 1, 
    roleName : "patient"
  },
  {
    roleId : 2 ,
    roleName : "doctor"
  },
  {
    roleId : 3, 
    roleName : "careadmin"
  },
];

export const PATIENT_ROLE = "patient";

export const ROLES= {
  "patient" : {
          src: icons?.multi_role_patient || "",
          title: "Client",
          description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
          role:"patient"
        },
  "doctor" : {
          src: icons?.multi_role_doctor || "",
          title: "Doctor",
          description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
          role:"doctor"
        },
  "careadmin" : {
          src: icons?.multi_role_care_admin || "",
          title: "Care Admin",
          description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
          role:"care-admin"
        },
  "client_admin" : {
          src: icons?.multi_role_spoc || "",
          title: "SPOC",
          description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
          role:"client-admin"
        },
  "super_admin" : {
          src: icons?.multi_role_super_admin || "",
          title: "Super Admin",
          description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
          role:"super_admin"
        },  
}
export const SUBSCRIPTION_MODES = [
    {
      label: "Popular Plans",
      value: "MONTHLY",
    },
    {
      label: "Single Consults",
      value: "ONCE",
    },
  ];

export const MEASURE_OPTIONS = [
  {
    value: "mg",
    label: "mg",
  },
  {
    value: "ml",
    label: "ml",
  },
  {
    value: "gms",
    label: "gms",
  },
];

export const DURATION_PERIOD_OPTIONS = [
  {
    value: "Day(s)",
    label: "Day(s)",
  },
  {
    value: "Week(s)",
    label: "Week(s)",
  },
  {
    value: "Month(s)",
    label: "Month(s)",
  },
  {
    value: "Year(s)",
    label: "Year(s)",
  },
];

export const CONSULTATION_TAB_OPTIONS = [
  {
    key: "Case Sheets",
    label: "Case Sheets",
  },
  {
    key: "Diagnosis",
    label: "Diagnosis",
  },
  {
    key: "Feedback Report",
    label: "Feedback Report",
  },
  {
    key: "Prescription",
    label: "Prescription",
  },
  {
    key: "Follow Up",
    label: "Follow Up",
  },
  {
    key: "Instructions",
    label: "Instructions",
  },
  {
    key: "Doctor Referral",
    label: "Doctor Referral",
  },
  {
    key: "Assessment Settings",
    label: "Assessment Settings",
  },
  {
    key: "Documents Upload",
    label: "Documents Upload",
  },
];

export const LANGUAGE_OPTIONS = [
  {
    value: "en",
    label: "English",
  },
  {
    value: "ta",
    label: "தமிழ்",
  },
  {
    value: "ml",
    label: "മലയാളം",
  },
  {
    value: "en_tn",
    label: "English / தமிழ்",
  },
  {
    value: "en_ml",
    label: "English / മലയാളം",
  },
];

export const REASON_OF_NIYAMA = [
  {
      option: "A",
      type: "Stress",
      label: "Need to reduce stress"
  },
  {
      option: "B",
      type: "Sleep",
      label: "Need to sleep better"
  },
  {
      option: "C",
      type: "Anxious",
      label: "Feeling anxious, fearful, panicky"
  },
  {
      option: "D",
      type: "Depression",
      label: "Feeling sad, hopeless, depressed"
  },
  {
      option: "E",
      type: "Psychological",
      label: "Need emotional or psychological support"
  }
];
export const OTHER_OPTIONS_FOR_NIYAMA_ADOLESCENT = [{
  option: "F",
  type: "Alcohol",
  label: "Alcohol/Substance dependence"
},
{
  option: "G",
  type: "Schizophrenia",
  label: "Schizophrenia"
},
{
  option: "H",
  type: "Bipolar",
  label: "Bipolar Disorder"
},
{
  option: "I",
  type: "Eating disorder",
  label: "Eating disorder"
},
{
  option: "J",
  type: "OCD",
  label: "Obsessive Compulsive Disorder (OCD)"
},
{
  option: "K",
  type: "PTSD",
  label: "Post Traumatic Stress disorders (PTSD)"
},
{
  option: "L",
  type: "ADHD",
  label: "Attention Deficit Hyperactivity Disorder (ADHD)"
},
{
  option: "M",
  type: "PMDD",
  label: "Premenstrual Dysphoric Disorder (PMDD)"
},
{
  option: "N",
  type: "LGBTQ",
  label: "Gender Identity (LGBTQ)"
},{
  option: "O",
  type: "others",
  label: "Other issues"
}];
export const OTHER_OPTIONS_FOR_NIYAMA_ADULT = [{
  option: "F",
  type: "Alcohol",
  label: "Alcohol/Substance dependence"
},
{
  option: "G",
  type: "Schizophrenia",
  label: "Schizophrenia"
},
{
  option: "H",
  type: "Bipolar",
  label: "Bipolar Disorder"
},
{
  option: "I",
  type: "Eating disorder",
  label: "Eating disorder"
},
{
  option: "J",
  type: "OCD",
  label: "Obsessive Compulsive Disorder (OCD)"
},
{
  option: "K",
  type: "PTSD",
  label: "Post Traumatic Stress disorders (PTSD)"
},
{
  option: "L",
  type: "ADHD",
  label: "Attention Deficit Hyperactivity Disorder (ADHD)"
},{
  option: "M",
  type: "PMDD",
  label: "Premenstrual Dysphoric Disorder (PMDD)"
},
{
  option: "N",
  type: "post depression",
  label: "Post-partum Depression"
},
{
  option: "O",
  type: "LGBTQ",
  label: "Gender Identity (LGBTQ)"
},{
  option: "P",
  type: "others",
  label: "Other issues"
}];
export const OTHER_OPTIONS_FOR_NIYAMA_SENIOR_ADULT = [{
  option: "F",
  type: "Alcohol",
  label: "Alcohol/Substance dependence"
},
{
  option: "G",
  type: "Schizophrenia",
  label: "Schizophrenia"
},
{
  option: "H",
  type: "Bipolar",
  label: "Bipolar Disorder"
},
{
  option: "I",
  type: "Eating disorder",
  label: "Eating disorder"
},
{
  option: "J",
  type: "OCD",
  label: "Obsessive Compulsive Disorder (OCD)"
},
{
  option: "K",
  type: "PTSD",
  label: "Post Traumatic Stress disorders (PTSD)"
},
{
  option: "L",
  type: "ADHD",
  label: "Attention Deficit Hyperactivity Disorder (ADHD)"
},
{
  option: "M",
  type: "LGBTQ",
  label: "Gender Identity (LGBTQ)"
}];

export const TS_STYLD_COMPS = [
  <span className="en-txt" />,
  <span className="ta-txt" />,
  <span className="ml-txt" />,
  <br />,
  <span className="hi-txt" />,
  <span className="te-txt"/>,
  <span className="kn-txt"/>,
];
export const VERSION_1_7_0 = ["send-otp-dup","otp-verification","b2b-set-new-password", "get-all-languages", "preferred-language-update","user-info","get-patient-status","banner-dashboard","profile-list","profile-detail","password-log-in","otp-verification","user-register","set-new-password-dup"];
export const VERSION_1_8_0 = [
  "list-patient-appointment",
  "list-all-past-appointments",
  "consultation-history-list",
  "my-appointment",
  "ca-list-all-consultations",
  "consultation-current-status",
  "patient-upcoming-appointment",
  "get-therapy-progress-note",
  "therapy-progress-save",
  "get-consultation-details",
  "therapy-progress-answer-list",
  "psychiatryfb-question-list",
  "psychiatryfb-question-save",
  "get-consultation-details",
  "publish-prescription",
  "psychiatryfb-answer-list",
  "preview-psychiatry-fb",
  "publish-psychiatry-fb",
  "view-files",
  "consultation-status",
  "preview-prescription",
  "get-available-slot",
  "get-available-doctors",
  "book-appoinment",
  "change-appointment",
  "appointment-status",
  "get-slots",
  "doctor-assignment",
  "get-patient-status",
  "patient-test-result-list",
  "order-list",
  "profile-list",
  "appointment-details",
  "banner-dashboard",
  "get-patient-summary"
];
export const VERSION_1_9_0 = [
  "assessment-submit",
  "get-patient-status",
  "patient-test-result-list",
  "assessment-question",
    "doctor-instruction",
    "ticket-list",
    "ticket-list-dup",
    "appointment-details",
    "my-patient-history-list-dup",
    "dsm-question-store",
    "mhe-question-store",
    "theraphy-question-store",
    "therapy-progress-save",
    "diagnosis-data-question-store",
    "pf-question-save",
    "dot-question-save",
    "sos-question-save",
    "case-formulation1-question-store",
    "case-formulation2-question-store",
    "psychiatryfb-question-save",
    "confas-question-save",
    "conpsyg-question-save",
    "concog-question-save",
    "ahi-phi-save",
    "mental-health-complaints-api",
    "physical-health-complaints-api",
    "past-mental-health-history-api",
    "past-hospitalization-history-api",
    "family-hospitalization-history-api",
    "mental-illness-in-family-api",
    "physical-illness-in-family-api",
    "birth-and-childhood-history-api",
    "educational-detail-api",
    "occupational-detail-api",
    "sexual-health-api",
    "energy-exercise-api",
    "sleep-detail-api",
    "medical-document-api",
    "delete-files",
    "constitutional-analysis-api",
    "menstruation-detail-api",
    "my-appointment",
    "dashboard",
    "plan-statistics",
    "profile-list",
    "profile-create",
    "user-register",
    "consultation-history-list",
    "user-info",
    "get-casenotes-list",
    "dsm-answer-list",
    "mhe-answer-list",
    "pf-answer-list",
    "dot-answer-list",
    "sos-answer-list",
    "get-case-formulation1-question-list",
    "case-formulation1-answer-list",
    "case-formulation2-answer-list",
    "psychiatryfb-answer-list",
    "diagnosis-data-answer-list",
    "multiple-file-ans-list",
    "concog-answer-list",
    "conpsyg-answer-list",
    "confas-answer-list",
    "banner-dashboard",
    "list-doctor-schedule",
    "ticket-list-dup",
    "list-all-patients",
    "corporate-user-list",
    "consultation-current-status",
    "ca-patient-detail",
    "patient-chat-token-details",
    "get-care-chat-status",
    "list-all-past-appointments",
    "list-patient-appointment",
    "get-patient-chat-status",
    "get-available-doctors",
    "ca-list-all-consultations",
    "patient-upcoming-appointment",
    "ahi-phi-summary",
    "therapy-progress-answer-list",
    "password-log-in",
    "profile-detail",
    "get-slots",
    "set-new-password-dup",
    "b2b-set-new-password", 
    "otp-verification",
    "multiple-files-upload",
    "multiple-file-delete",
    "add-prescription",
    "add-casenotes",
    "consultation-status",
    "medical-document-search-suggestion",
    "add-medical-test",
    "preview-medical-prescription",
    "make-outgoing-call",
    "list-all-tickets",
];

export const VERSION_1_9_1=[
"medical-document-search-suggestion",  
"upload-files",
"list-medical-documents",
    "medical-document-search-suggestion",
    "add-medical-test",
    "preview-medical-prescription",
    "publish-medical-prescription",
    "add-prescription",
    "all-prescription-list",
    "publish-prescription",
    "subscription-plan-list",
  "doctor-list",
  "ticket-list",
  "ticket-list-dup",
  "get-available-doctors",
  "ahi-summary",
  "patient-detail",
  "generate-pdf-content",
  "get-prescription-list",
  "all-prescription-summary-list",
]

export const VERSION_1_10_0=[  
  "export-corporate-user-list",
  "diagnosis-data-question-list",
  "diagnosis-data-question-store",
  "diagnosis-data-answer-list",
  "coupon-list",
  "admin-comment-for-rating",
  "update-coupon-expiry",
  "get-theraphy-question-list",
  "get-therapy-progress-note",
  "get-quick-sight-data",
  "get-quick-sight-uid",
  "theraphy-answer-list",  
  "get-bpi-chart-summary",
  "therapy-progress-answer-list",
  "get-consultation-details",
  "therapy-progress-save",
  "theraphy-question-store",
  "consultation-status",
  "next-consultation-create",
  "di-name-suggestion",
  "save-new-coupon",
  "check-role", 
  "get-patient-status", 
  "password-log-in",
  "get-doctor-status",
  "get-care-admin-status",
  "get-client-admin-status",
  "get-language-details",
  "get-age-group-details",
  "get-funnelling-data",
  "funneling-question-age-group-submit",
  "funneling-question-submit",
  "b2b-set-new-password",
  "otp-verification",
  "verify-otp-dup",
  "set-new-password-dup",
  "user-register",
  "check-export-status",
  "save-funneling-language",
  "assessment-question-submit",
  "assessment-submit",
  "email-mobile-verify",
]

export const VERSION_1_11_0=[  
  "consultation-status",
  "consultation-history-list",
  "list-all-past-appointments",
  "get-quicksight-url",
  "get-available-slot",
  "doctor-list",
  "get-slots",
  "ticket-list",
  "ticket-list-dup",
  "doctor-instruction",
  "pending-tickets",
  "ticket-list",
  "ticket-list-dup", 
  "doctor-instruction-list",
  "consultation-current-status",  
  "admin-comment-for-rating",
]
export const AI_FORM_ITEMS_KEY_REPLACER = {
  type_of_exercise : "Exercise",
  // is_onset_first_concern: "",
  // onset_first_concern_value: "",
  // recurrent_value: "",
  // if_other:"",
  // is_drugs: "",
  // is_abuse: "",
  // is_recurrent: "",
  // is_emotional_abuse: "",
  // sexual_abuse_value: "",
  duration_period: "Duration Period",
  duration: "Duration",
  quantity: "Quantity",
  // is_abstinence: "",
  reason_for_relapse: "Reason",
  presenting_mental_health_complaints: "Presenting Complaints",
  //Presenting mental health complaints
  // is_sexual_abuse : "",
  // is_physical_abuse : "",
  physical_abuse_value: "Physical Abuse Faced",
emotional_abuse_value : "Emotional Abuse Value",
    // substance dependence
  // is_substance_dependence : "",
  // is_cannabis : "",
  // is_smoking : "",
  // is_alcohol : "",
  symptoms : "Symptoms",
  frequency : "Frequency",
  reccurent_value: "Recurent Value",

  //physical health complaints
  // is_diabetes : "",
  // is_hypertension  : "",
  // is_cancer : "",
  // is_cardiac_ailment : "",
  // is_parkinson_disorder  : "",
  // is_thyroid : "",
  // is_chronic_illness : "",
  // is_past_episode_of_covid_19  : "",
  // is_cholesterol : "",
  // is_asthma_lungs_problem : "",
  // is_headache_or_migraine : "",
  // is_copd : "",
  // is_constipation : "",
  // is_acid_reflux : "",
  // is_gastritis_bloating : "",
  // is_cardiac_problems  : "",
  // is_epilepsy_seizures_fits  : "",
  medication : "Medication",
  // is_mental_illness : "",
  job_attitude: "Job Attidude",
  job_frequency: "Job Frequency",
  number_of_job_in_last_2_years: "Number of jobs in last 2 years",
  job_attendance : "Job Attendance",
  other_habit :"Other habit",
  major_childhood_illness :"Major childhood illness",
  other_illness:"Other illness",
  
  // Education Details
  // is_change_of_institute : "",
  number_of_close_friends : "Number of close friends",
  relationship_with_friends : "Relationship with friends",
  is_persue_any_hobby : "Pursue Any Hobby",
  if_persue_any_hobby : "Hobby",
  if_others : "Others",
  highest_educational_qualification : "Highest educational qualification",
  if_cramps:"Menstruation cramps",
  if_mensuration_cramp:"Menstruation cramps",

};
export const LANG_STYLD_EXT = "_st";

export const FAQ_INIT_TEXT =  "hi";

export const PRIMARY_LANG = "en";

export const INCLUDE_PRIME_LANG_LABEL = "Include English";

export const NETWORK_BACK_MSG = "Your internet connection is back online, please wait...";

export const SOMETHING_WRONG_MSG =  "Oops! something went wrong";

export const OFFLINE_MSG = "No Internet Connection";

export const ONLINE_MSG = "Back Online";

export const CHAT_SER_NOT_AVAIL_MSG = "Please try again later as this service is currently not available.";

export const SUCCESS_CODE = 200;

export const AI_BOT_CHAT_TYPE = "aibot_chat";

export const LIVE_CHAT_TYPE = "live_chat";

export const CHECK_NETWORK_MSG = "Please check your internet connection and try again";

export const INVALID_TIME_ERROR_TXT = `Invalid time. Please enter the time in the format "HH am|pm" eg."01 am"`;

export const END_LESSTHAN_START_TXT = "End time cannot be less than or equal to the start time";

export const CHAT_CLOSE_POP_TITLE = "Are you sure you want to close this chat?";

export const TIMEZONE_INFO_TEXT = "*Timezones are automatically adjusted for Daylight Savings Time. If the displayed time zone is not automatically adjusted in your region please contact care admin.";

export const consentformstring = { header:"Parental Consent for Child/Adolescent  Health  Treatment",
footer:" Health treatment methods [such as Psychotherapy and Pharmacotherapy] are most effective when a trusting relationship exists between the child/adolescent and the clinician [Psychotherapist/Psychiatrist]. It is hence necessary for children/adolescents to establish a “zone of privacy” with their psychotherapists/psychiatrists allowing them to discuss personal matters freely. Therefore, while we will provide you with general information about the assessment and treatment of your child/adolescent during Parental Check in sessions, it may not be possible to share everything that your child/adolescent has disclosed to us as we are dictated by the medical code of conduct and privacy, akin to any client-healthcare provider relationship. However, if the child/adolescent is at serious risk of harming him/herself or another, or if there are any other issues of medico-legal implications, we will definitely inform you. In case of disagreement among parents themselves and/or disagreement between parents and the psychotherapist/psychiatrist regarding the treatment of the child/adolescent, and despite earnest efforts to address these disagreements, if either parent decides to terminate treatment, we shall request the option of having a few closing sessions with the child/adolescent to end treatment appropriately without adversely impacting the child/adolescent’s mental health. You will also kindly understand and agree that our role is strictly limited to providing psychotherapy/psychiatric sessions for the benefit of your child/adolescent mental health and wellness care. Please treat anything said in Parental check-in sessions as strictly confidential. You agree that you will not involve us in any legal dispute, especially those concerning parental separation/divorce proceedings, child custody or visitation arrangements. We are ethically bound not to give our opinion about the suitability of either parent’s custody or visitation rights. You will not ask us to testify in court, either in person or by affidavit. If you have any questions about the information contained in this contract, please discuss them with us prior to signing below. Clicking yes indicates that you have a) obtained the assent of your child/adolescent implying his approval for his assessment and treatment and b) you hereby give your consent to your child/adolescent’s  health treatment and have thereby entered into a legally binding agreement with the terms set forth in this contract. "}
